module.exports = __webpack_public_path__ + "static/img/WarmPlate (13).9148d24d.png";